import React from 'react';
import { Link } from 'react-router-dom'; 

//COMPONENTS
import { Row, Column, IBox, Title, Content, Button, Icon, Select } from '../inspinia';
import Pagination from 'react-js-pagination';
import { withRouter } from 'react-router-dom';

//MASK
import InputMask from 'react-input-mask';

//HELPERS
import * as c from '../../helpers/constants';
import { callApi } from '../../helpers/methods'
import { isBlank } from '../../helpers/stringHelper';

//REDUX
import { connect } from 'react-redux';
import { CircularProgress } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import { mailingAction } from '../../store/anexos';

import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

class MonitoramentoMailing extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            form: {
                dataInicio: "",
                dataFim: "",
                status: { id: 0 }
            },
            campanhaValues: {
                value: "",
                label: ""
            },
            comboNomeCampanhasAutoComplete: [],
            comboNomeCampanhas:
            {
                results: undefined
            },
            rotinaDisabled: false,
            list:
            {
                currentPage: 0, pageNumber: 0, size: 0, totalElements: 0, content: undefined
            },
            comboStatus:
            {
                results: undefined
            },
            comboNomeMailings:
            {
                results: undefined
            },
            comboNomeMailingsAutoComplete: [],
            mailingValues: {
                value: "",
                label: ""
            },
            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } }
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleBuscar = this.handleBuscar.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.onNomeCampanhaChange = this.onNomeCampanhaChange.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.onNomeMailingChange = this.onNomeMailingChange.bind(this);
    }

    handleChange(e) {
        const form = this.state.form;
        this.setState({ form: { ...form, [e.target.name]: e.target.value } });
    }

    onNomeMailingChange = (event, values) => {
        const form = this.state.form;
        let mailingCombo = '';

        if (values) {
            mailingCombo = values.value;
        }

        this.setState({ form: { ...form, 'mailing': mailingCombo } });
        this.setState({ ...this.state, mailingValues: values });

    }

    componentDidMount() {
        this.loadListaAgendamentoMailing();
    }

    LoadComboMailings() {
        const self = this;

        const url = `${c.API_BASE_URL}/mailing-list`;
        const options = self.state.optionsGet;

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboNomeMailings: response });
            self.setState({ ...self.state, loading: false, comboNomeMailingsAutoComplete: response });
        });
    }

    LoadComboStatus() {
        const self = this;
        const mockStatus = { results: [{ value: "0", label: "DADOS NÃO ENCONTRADOS" }, { value: "1", label: "EM ANDAMENTO" }, { value: "2", label: "GERADO" }] };
        self.setState({ ...self.state, comboStatus: mockStatus });

    }

    LoadComboNomeCampanhas() {
        const self = this;

        const url = `${c.API_BASE_URL}/toi-campanhas`;
        const options = self.state.optionsGet;

        callApi(url, options, function (response) {
            self.setState({
                ...self.state,
                comboNomeCampanhas: response,
                comboNomeCampanhasAutoComplete: response.results
            });
        });
    }

    onNomeCampanhaChange = (event, values) => {
        const form = this.state.form;
        let campanhaCombo = '';

        if (values) {
            campanhaCombo = values.value;
        }

        this.setState({
            ...this.state,
            form: {
                ...form,
                'campanha': campanhaCombo
            },
            campanhaValues: values
        });
    }

    limparFormulario() {
        const state = this.state;

        const select = document.querySelector('select');
        select.value = "Selecione...";

        this.setState({
            ...state,
            form: {
                dataInicio: "",
                dataFim: "",
                status: { id: 0 },
            },
            campanhaValues: {
                value: "",
                label: ""
            }
        })
    }

    handleBuscar(pageNumber) {
        const self = this;
        const state = self.state;
        let page = pageNumber === undefined ? 0 : --pageNumber;
        let size = 10;

        self.setState({ ...state, loading: true });

        if (isBlank(state.form.dataInicio)) {
            c.TOASTER_INFO("Data Início precisa ser preenchida.");
            self.setState({ ...state, loading: false });
            return;
        }

        if (isBlank(state.form.dataFim)) {
            c.TOASTER_INFO("Data Fim precisa ser preenchida.");
            self.setState({ ...state, loading: false });
            return;
        }


        const url = `${c.API_BASE_URL}/buscarStepMailing?page=${page}&size=${size}`;
        const options =
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                dataInicio: state.form.dataInicio,
                dataFim: state.form.dataFim,
                status: null,
                idMailing: null
            })
        };

        callApi(url, options, function (response) {
            if (response.content) {
                self.setState({ ...self.state, list: response });
            }

        });

        self.setState({ ...state, loading: false });
    }

    loadListaAgendamentoMailing(pageNumber) {
        const self = this;
        let page = pageNumber === undefined ? 0 : --pageNumber;
        let size = 10;
        
        const url = `${c.API_BASE_URL}/monitoramentoMailings?page=${page}&size=${size}`;
        const options = self.state.optionsGet;

        callApi(url, options, function (response) {
            self.setState({ ...self.state, list: response, loading: false });
        });
    }


    handlePageChange(pageNumber) {
        let self = this;
        this.state.page = pageNumber;

        if (self.state.form.dataInicio == "" && self.state.form.dataFim == "") {
            this.loadListaAgendamentoMailing(pageNumber);
        } else {
           this.handleBuscar(pageNumber);
        }
    }

    render() {
        return (

            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-0">
                    <Column>
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Upload de Anexos</h3>
                            </Title>

                            <Content>
                                <Row>
                                    <Column size="2" className="p-1 mx-auto container">
                                        <label>Data Inicio:</label>
                                        <InputMask mask="99/99/9999" name="dataInicio" value={this.state.form.dataInicio} placeholder="___/___/___" onChange={this.handleChange} readOnly={this.state.process} className="form-control" />
                                    </Column>

                                    <Column size="2" className="p-1 mx-auto container">
                                        <label>Data Fim:</label>
                                        <InputMask mask="99/99/9999" name="dataFim" value={this.state.form.dataFim} placeholder="___/___/___" onChange={this.handleChange} readOnly={this.state.process} className="form-control" />
                                    </Column>

                                    <Column size="2" className="p-1 mx-auto container">

                                    </Column>

                                    <Column size="auto" className="p-1 mx-auto container" style={{ top: "30px" }}>
                                        <div className="input-group" >
                                            <Button className="mx-1" onClick={this.handleBuscar} width="130px">Buscar</Button>

                                            <div className="ml-4">
                                                {this.state.loading && (
                                                    <CircularProgress
                                                        size={30}
                                                        thickness={4}
                                                        color='inherit'
                                                        variant='indeterminate' />
                                                )}
                                            </div>
                                        </div>
                                    </Column>

                                </Row>

                                <Row className="m-0 mb-3">

                                </Row>

                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">
                                        <Table data={this.state.list} history={this} buscar={this.state.buscar} loading={this.state.loading} contexto={this}/>
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>
                    </Column>
                </Row>
                {/* FOOTER */}
                <Row className="mb-4">
                    <Column className="container">
                        <Row>
                            <Column size="12" className="text-center">
                                <div className="d-flex justify-content-center">

                                    <Pagination
                                        hideNavigation
                                        pageRangeDisplayed={c.DEFAULT_PAGE_RANGE}
                                        activePage={this.state.page}
                                        itemsCountPerPage={this.state.list.size}
                                        totalItemsCount={this.state.list.totalElements}
                                        onChange={this.handlePageChange}
                                    />

                                </div>
                            </Column>
                        </Row>
                    </Column>
                </Row>
            </div>
        );
    }
}

class Table extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            selfMain: props.history,
            historyMain: props.history.props.history,
            alerta: withReactContent(Swal),
            loading: false,
        }

        this.handleConfirmar = this.handleConfirmar.bind(this);
        this.handleMailing = this.handleMailing.bind(this);
        this.onClickConfirmar = this.onClickConfirmar.bind(this);
        this.handlePopupCount = this.handlePopupCount.bind(this);
        this.onClickCount = this.onClickCount.bind(this);
        this.ajustaData = this.ajustaData.bind(this);
        this.handleStatus = this.handleStatus.bind(this);
    }

    ajustaData(str) {
        if (str != null && str != undefined && str != "") {
            var splitDataHora = str.split(' ');
            var anoMesAno = splitDataHora[0].split('-');
            var ano = anoMesAno[0];
            var mes = anoMesAno[1];
            var dia = anoMesAno[2];
            
        
            return dia + "/" + mes + "/" + ano + " " + splitDataHora[1].split('.')[0];

        } else {
            return "";
        }

        
    }

    handleMailing(mailing) {
        this.props.history.props.actions.mailing.uploadMaliling(mailing);        
    }
    
    handleConfirmar(idMailing) {
        this.onClickConfirmar(idMailing);     
    }

    onClickConfirmar(idMailing) {
        this.state.alerta.fire({
            title: 'Realmente deseja confirmar o processamento?',
            text: 'Essa ação é irreversível!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#47A789',
            cancelButtonColor: '#ED5358',
            reverseButtons: true,
            preConfirm: () => {
                return this.LoadConfirmar(idMailing);
            },
            allowOutsideClick: () => !this.state.alerta.isLoading(),
            showLoaderOnConfirm: true,
            backdrop: true,
        }).then((result) => {
            if (result.dismiss === Swal.DismissReason.cancel) {
                this.state.alerta.fire({
                    title: 'Cancelado',
                    text: 'Processamento não confirmado',
                    icon: 'error',
                    confirmButtonColor: '#47A789'
                })
            }
        });
    }

    LoadConfirmar(idMailing) {
        let url = `${c.API_BASE_URL}/confirmar-processamento?mailing=${idMailing}`;
        const self = this;

        const options =
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        };

        callApi(url, options, function (response) {
            if (response.status === 200) {
                self.props.contexto.loadListaAgendamentoMailing(0);
                c.TOASTER_SUCCESS("Processamento confirmado com sucesso!"); 
            }
        });
    }

    onClickCount(idMailing) {

        let url = `${c.API_BASE_URL}/count-mailing/${idMailing}`;
        const self = this;
        const options =
        {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        callApi(url, options, function (response) {
            if (response.status === "OK") {                      
                self.setState(self.handlePopupCount(response.count));               
            } else {
                c.TOASTER_ERROR("Erro ao processar as informações!"); 
            }
        });
    }

    handlePopupCount(count) {
        
        this.state.alerta.fire({
            icon: 'info',
            title: 'Anexos:',
            html: `<strong>${count}</strong>`,
            confirmButtonColor: '#47A789',
        });
    }

    handleStatus(processado, confirmado) {
        if (processado && confirmado) {
            return 'Processado';
        } else if (confirmado) {
            return 'Em processamento';
        } else {
            return 'Aberto';
        }
    }

    render() {
        const loading = this.props.loading;
        const data = this.props.data;
        let html = "";

        if (loading) {
            html = (<tr><td colSpan="8" scope="row">Carregando Agendamentos...</td></tr>);
        }
        else if (data.length === 0 || data.content === undefined || data.content.length === 0) {
            html = (<tr><td colSpan="8" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.content.length > 0) {
            
            html = data.content.map(row =>
                <tr key={row.id} id={row.id}>
                    <td className="text-center" style={{width: '70px'}}>{row.id}</td>
                    <td><div style={{wordBreak: 'break-word', width: '275px'}}>{row.nome}</div></td>
                    <td className="text-center" style={{width: '225px'}}>{this.ajustaData(row.dataSolicitacao)}</td>
                    <td className="text-center"style={{width: '225px'}}>{this.ajustaData(row.dataProcessamento)}</td>
                    <td className="text-center" style={{width: '70px'}}>{row.nomeEmpresa}</td>
                    <td className="text-center" style={{width: '70px'}}>{row.nomeFilial}</td>
                    <td className="text-center" style={{width: '70px'}}>{this.handleStatus(row.processado, row.confirmado)}</td>
                    <td>
                        <div className="text-center" style={{ display: (!this.state.loading ? 'block' : 'none'), width: '170px' }}>
                            <Button onClick={() => this.onClickCount(row.id)} background='transparent' border='none' ><Icon name="fas fa-info" className="mx-1 text-info text-center" /></Button>
                            <Button onClick={() => this.handleConfirmar(row.id)} disabled={row.confirmado} background='transparent' border='none' ><Icon name="fa-paper-plane" className="mx-1 text-info text-center" /></Button>                        
                            <Link to={c.STAMP_ROUTE + "/anexos-upload"} style={{ pointerEvents: (row.confirmado) ? 'none' : 'auto' }}>
                                <Button onClick={() => this.handleMailing(row.id)} background='transparent' border='none' ><Icon name="fas fa-upload" className="mx-1 text-info text-center" /></Button>
                            </Link>                          
                        </div>
                        {this.state.loading && (
                            <CircularProgress
                                size={30}
                                thickness={4}
                                color='inherit'
                                variant='indeterminate' />
                        )}
                    </td>
                </tr>
            );
        }

        return (
            <table className="footable table table-striped toggle-arrow-tiny text-body">
                <thead>
                    <tr style={{ backgroundColor: "#dbf1e9" }}>
                        <th className="text-center">#</th>
                        <th>Nome</th>
                        <th className="text-center">Data Solicitação</th>
                        <th className="text-center">Data Processamento</th>
                        <th className="text-center">Empresa</th>
                        <th className="text-center">Filial</th>
                        <th className="text-center">Status</th>
                        <th className="text-center">Ações</th>
                    </tr>
                </thead>

                <tbody>{html}</tbody>
            </table>
        )
    }
}


function mapStateToProps(state) {
    return { auth: state.auth, mailing: state.mailing };
}

function mapDispatchToProps(dispatch) {
    return {actions: { mailing: bindActionCreators(mailingAction, dispatch) }};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MonitoramentoMailing));